// extracted by mini-css-extract-plugin
export default {"Outer":"AppPriceInput_Outer__bMQ22"};